export default {"src":"/_next/static/media/footerTopWelcomePetsitting.78182f72.svg","height":261,"width":386,"blurWidth":0,"blurHeight":0};